import { useCallback } from 'react';
import { Tag } from 'antd';
import { STATUS_COLORS, STATUS_ICONS } from '../constants';

export const useStatusRender = () => {
  return useCallback((status: string) => {
    if (!status) return '-';
    
    const color = STATUS_COLORS[status as keyof typeof STATUS_COLORS] || 'default';
    const icon = STATUS_ICONS[status as keyof typeof STATUS_ICONS] || null;
    
    return (
      <Tag 
        color={color} 
        icon={icon}
        style={{ fontWeight: 500 }}
      >
        {status}
      </Tag>
    );
  }, []);
};